/* eslint-disable jsx-a11y/click-events-have-key-events */
import cn from 'classnames/bind';
import React, { FC } from 'react';

import { IconProps } from './Icon.types';
import styles from './Icon.module.css';

const cx = cn.bind(styles);

const Icon: FC<IconProps> = ({ type, size, className, position = 'relative' }) => (
    <div
        className={cx(
            'root',
            `root_type_${type}`,
            `root_size_${size}`,
            `root_position_${position}`,
            className
        )}
    />
);

export default Icon;
